import { useEffect, useMemo, useRef, useState } from 'react';
import { JustifiModules, useJustifiLoaderShallowStore } from '../stores';

export const useJustifiLoadedState = <T extends JustifiModules>(modulesToCheck: T[]) => {
  const { getModuleStatus, components } = useJustifiLoaderShallowStore('getModuleStatus', 'components');

  const memoizedModules = useMemo(() => {
    return modulesToCheck;
  }, [modulesToCheck.join(',')]);

  const getCheckedModuleStates = () => {
    return memoizedModules.reduce((acc, moduleName) => {
      return { ...acc, [moduleName]: getModuleStatus(moduleName) };
    }, {} as Record<T, ReturnType<typeof getModuleStatus>>);
  };

  const [statuses, setStatuses] = useState(getCheckedModuleStates());
  const prevValue = useRef(statuses);

  useEffect(() => {
    const currentValue = getCheckedModuleStates();

    if (JSON.stringify(currentValue) !== JSON.stringify(prevValue.current)) {
      prevValue.current = currentValue;
      setStatuses(currentValue);
    }
  }, [components, memoizedModules]);

  return statuses;
};
